export const SHIFT_TYPES = {
  surgical_assessment: {
    label: "Surgical Assessment Shift",
    defaultTitle: "Surgical Assessment Shift",
    fields: { briefing: true, admissions: true, hospital: true, location: true },
    positions: [
      { key: "sau_nurse_in_charge", label: "SAU Nurse in Charge", section: "Shift Leadership", capacity: 1 },
      { key: "senior_physician_in_charge", label: "Senior Physician in charge", section: "Shift Leadership", capacity: 1 },
      { key: "on_call_general_surgeon", label: "On call General Surgeon", section: "On Call Team", capacity: 1 },
      { key: "on_call_to_surgeon", label: "Oncall T&O Surgeon", section: "On Call Team", capacity: 1 },
      { key: "on_call_cardiothoracic_surgeon", label: "Oncall Cardiothoracic Surgeon", section: "On Call Team", capacity: 1 },
      { key: "on_call_anaesthetist", label: "Oncall Anaesthetist", section: "On Call Team", capacity: 1 },
      { key: "scrub_nurses", label: "Scrub Nurses", section: "Theatre Team", capacity: 10 },
      { key: "operating_department_practitioner", label: "Operating Department Practitioner", section: "Theatre Team", capacity: 5 },
      { key: "recovery_post_op_nurse", label: "Recover/Post op Nurse", section: "Theatre Team", capacity: 10 },
    ],
  },

  emergency_department: {
    label: "Emergency Department Shift Allocation",
    defaultTitle: "Emergency Department Shift Allocation",
    fields: { briefing: true, admissions: true, majorInjuries: true, location: true },
    positions: [
      { key: "ed_nurse_in_charge", label: "ED Nurse in Charge", section: "Shift Leadership", capacity: 1 },
      { key: "emergency_physician_in_charge", label: "Emergency Physician in Charge", section: "Shift Leadership", capacity: 1 },
      { key: "triage_1", label: "Triage 1", section: "Triage", capacity: 1 },
      { key: "triage_2", label: "Triage 2", section: "Triage", capacity: 1 },
      { key: "majors_minors_doctors", label: "MAJORS/MINORS Doctors", section: "MAJORS / MINORS", capacity: 10 },
      { key: "majors_minors_nurses", label: "MAJORS/MINORS Nurses", section: "MAJORS / MINORS", capacity: 10 },
      { key: "majors_minors_csws", label: "MAJORS/MINORS CSW's", section: "MAJORS / MINORS", capacity: 10 },
      { key: "resus_coordinator_dr", label: "RESUS Coordinator (DR)", section: "RESUS", capacity: 1 },
      { key: "resus_coordinator_nurs", label: "RESUS Coordinator (NURS)", section: "RESUS", capacity: 1 },
      { key: "resus_doctors", label: "RESUS Doctor(s)", section: "RESUS", capacity: 10 },
      { key: "resus_nurses", label: "RESUS Nurse(s)", section: "RESUS", capacity: 10 },
      { key: "resus_csws", label: "RESUS CSW's", section: "RESUS", capacity: 10 },
      { key: "on_call_2222_team_lead", label: "On Call 2222 Team Lead", section: "On Call 2222 Team", capacity: 1 },
      { key: "on_call_2222_practitioners", label: "On Call 2222 Practitioner(s)", section: "On Call 2222 Team", capacity: 10 },
    ],
  },

  utc: {
    label: "UTC Shift Allocation",
    defaultTitle: "UTC Shift Allocation",
    fields: { briefing: true, admissions: true, location: true },
    positions: [
      { key: "nurse_in_charge", label: "Nurse in Charge", section: "Shift Leadership", capacity: 1 },
      { key: "consultant_physician_in_charge", label: "Oncall Consultant/Physician in Charge", section: "Shift Leadership", capacity: 1 },
      { key: "triage_1", label: "Triage 1", section: "Triage", capacity: 1 },
      { key: "triage_2", label: "Triage 2", section: "Triage", capacity: 1 },
      { key: "consult_1", label: "Consult 1", section: "Consulting Team", capacity: 1 },
      { key: "consult_2", label: "Consult 2", section: "Consulting Team", capacity: 1 },
      { key: "consult_3", label: "Consult 3", section: "Consulting Team", capacity: 1 },
      { key: "consult_4", label: "Consult 4", section: "Consulting Team", capacity: 1 },
      { key: "nursing_team", label: "Nursing Team", section: "Consulting Team", capacity: 10 },
      { key: "hcsws", label: "HCSW's", section: "Consulting Team", capacity: 10 },
      { key: "radiology", label: "RADIOLOGY", section: "Diagnostics / Support", capacity: 10 },
      { key: "pathology_plaster", label: "PATHOLOGY/PLASTER", section: "Diagnostics / Support", capacity: 10 },
    ],
  },

  outpatient_department: {
    label: "Outpatient Department Shift Allocation",
    defaultTitle: "Outpatient Department Shift Allocation",
    fields: { briefing: true, location: true },
    positions: [
      { key: "outpatient_nurse_in_charge", label: "Outpatient Department Nurse in Charge", section: "Shift Leadership", capacity: 1 },
      { key: "consultant_clinical_lead", label: "Consultant / Clinical Lead", section: "Shift Leadership", capacity: 1 },
      { key: "clinic_room_1", label: "Clinic Room 1", section: "Clinic Rooms", capacity: 1 },
      { key: "clinic_room_2", label: "Clinic Room 2", section: "Clinic Rooms", capacity: 1 },
      { key: "treatment_room_1", label: "Treatment Room 1", section: "Clinic Rooms", capacity: 1 },
      { key: "treatment_room_2", label: "Treatment Room 2", section: "Clinic Rooms", capacity: 1 },
      { key: "phlebotomy_room", label: "Phlebotomy Room", section: "Specialist Rooms", capacity: 5 },
      { key: "casting_room", label: "Casting Room", section: "Specialist Rooms", capacity: 5 },
    ],
  },

  inpatient_ward: {
    label: "Inpatient Ward Shift Allocation",
    defaultTitle: "Inpatient Ward Shift Allocation",
    fields: { briefing: true, ward: true, dayNight: true, location: true },
    positions: [
      { key: "ward_manager_session_host", label: "Ward Manager (Session Host)", section: "Shift Leadership", capacity: 1 },
      { key: "nurse_in_charge", label: "Nurse in Charge (NIC)", section: "Shift Leadership", capacity: 1 },
      { key: "consultant_on_call", label: "Consultant On Call", section: "Shift Leadership", capacity: 1 },
      { key: "flow_nurse", label: "Flow Nurse", section: "Shift Leadership", capacity: 1 },
      { key: "nurses_base", label: "Nurses Base", section: "Nursing Team", capacity: 10 },
      { key: "on_call_bleep", label: "On Call Bleep", section: "Medical Team", capacity: 1 },
      { key: "sho", label: "SHO", section: "Medical Team", capacity: 1 },
      { key: "rotation_doctors", label: "Rotation Doctors", section: "Medical Team", capacity: 10 },
      { key: "2222_lead", label: "2222 Lead", section: "2222 Team", capacity: 1 },
      { key: "2222_practitioner", label: "2222 Practitioner", section: "2222 Team", capacity: 1 },
    ],
  },

  ambulance: {
    label: "Ambulance Shift",
    defaultTitle: "Ambulance Shift",
    fields: { briefing: true, shiftStart: true, location: true },
    positions: [
      { key: "duty_operations_officer", label: "Duty Operations Officer", section: "Operational Leadership", capacity: 1 },
      { key: "raft_coordinator", label: "RAFT Coordinator", section: "Operational Leadership", capacity: 1 },
      { key: "raft_doctors", label: "RAFT Doctor's", section: "RAFT Team", capacity: 3 },
      { key: "raft_nurses", label: "RAFT Nurse's", section: "RAFT Team", capacity: 4 },
      { key: "dom_rrv", label: "DOM RRV", section: "Vehicles / Crews", capacity: 1 },
      { key: "rrv_1", label: "RRV 1", section: "Vehicles / Crews", capacity: 1 },
      { key: "dca_1", label: "DCA 1", section: "Vehicles / Crews", capacity: 1 },
      { key: "dca_2", label: "DCA 2", section: "Vehicles / Crews", capacity: 1 },
      { key: "dca_3", label: "DCA 3", section: "Vehicles / Crews", capacity: 1 },
    ],
  },
};

export function positionsForType(type) {
  return (SHIFT_TYPES[type] || SHIFT_TYPES.emergency_department).positions;
}

export function fieldsForType(type) {
  return (SHIFT_TYPES[type] || SHIFT_TYPES.emergency_department).fields || {};
}
